import React from 'react'
import { Modal } from 'react-bootstrap'

export default function CompleteStep4Grommet({
 pageLanguage,
 modals,
 modalHandleClose,
 t
}) {
  return (
   <Modal
   dialogClassName={`noMount_modal mediumSizeModal ${
     pageLanguage === "fa" ? "font_farsi" : "font_en"
   }`}
   show={modals["noMount"] === undefined ? false : modals["noMount"]}
   onHide={() => modalHandleClose("noMount")}
 >
   <Modal.Header closeButton></Modal.Header>
   <Modal.Body>
     <p>{t("modal_select_mount_grommet3")}</p>

     <br />
     <div className=" text_center">
       <button className=" btn btn-new-dark" onClick={() => modalHandleClose("noMount")}>
         {t("CONTINUE")}
       </button>
     </div>
   </Modal.Body>
 </Modal>
  )
}
